import React, { useState } from "react";
import {
  collection,
  query,
  where,
  getDocs,
  setDoc,
  doc,
  updateDoc,
  serverTimestamp,
  getDoc,
} from "firebase/firestore";
import { useSelector } from "react-redux";
import { SelectUser } from "../../../../store/usersSlice";
import { db } from "../../../../firebase";
import { Input } from "antd";
import { UserOutlined } from "@ant-design/icons";
const Search = () => {
  const [username, setUsername] = useState("");
  const [user, setUser] = useState(null);
  const [err, setErr] = useState(false);

  const currentUser = useSelector(SelectUser);

  const handleSearch = async () => {
    const q = query(
      collection(db, "companies", currentUser?.companyName, "users"),
      where("profile.firstName", "==", username)
    );

    console.log("query", q);

    try {
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        setUser(doc.data());
      });
    } catch (err) {
      setErr(true);
    }
  };

  const handleKey = (e) => {
    e.key === "Enter" && handleSearch();
  };

  console.log("User", user);

  const handleSelect = async () => {
    //check whether the group(chats in firestore) exists, if not create
    const combinedId =
      currentUser.uid > user.uid
        ? currentUser.uid + user.uid
        : user.uid + currentUser.uid;
    try {
      const res = await getDoc(doc(db, "chats", combinedId));

      if (!res.exists()) {
        //create a chat in chats collection
        await setDoc(
          doc(db, "companies", currentUser?.companyName, "chats", combinedId),
          { messages: [] }
        );

        //create user chats
        await updateDoc(
          doc(
            db,
            "companies",
            currentUser?.companyName,
            "userChats",
            currentUser.uid
          ),
          {
            [combinedId + ".userInfo"]: {
              uid: user.uid,
              displayName: user.profile.firstName + " " + user.profile.lastName,
            },
            [combinedId + ".date"]: serverTimestamp(),
            [combinedId + ".label"]:
              user.profile.firstName + " " + user.profile.lastName,
            [combinedId + ".icon"]: "UserOutlined",
          }
        );

        await updateDoc(
          doc(db, "companies", currentUser?.companyName, "userChats", user.uid),
          {
            [combinedId + ".userInfo"]: {
              uid: currentUser.uid,
              displayName: currentUser?.firstName + " " + currentUser?.lastName,
            },
            [combinedId + ".date"]: serverTimestamp(),
            [combinedId + ".label"]:
              currentUser?.firstName + " " + currentUser?.lastName,
            [combinedId + ".icon"]: "UserOutlined",
          }
        );
      }
    } catch (err) {}

    setUser(null);
    setUsername("");
  };
  return (
    <div className="search">
      <div className="searchForm">
        <Input
          placeholder="Find a user to chat with"
          onKeyPress={handleKey}
          onChange={(e) => setUsername(e.target.value)}
          value={username}
          style={{
            marginInline: "10px",
            marginBottom: "20px",
            maxWidth: "180px",
          }}
        />
      </div>
      {err && <span>User not found!</span>}
      {user && (
        <div className="userChat" onClick={handleSelect}>
          <div className="userChatInfo" style={{ cursor: "pointer" }}>
            <span style={{ marginLeft: 10, marginBottom: 20 }}>
              <UserOutlined /> {user.profile.firstName}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Search;
